import { render, staticRenderFns } from "./UtilitySingle.vue?vue&type=template&id=63dfad42&scoped=true&"
import script from "./UtilitySingle.vue?vue&type=script&lang=js&"
export * from "./UtilitySingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfad42",
  null
  
)

export default component.exports